import {myProjectCandidates} from './MyProjectCandidates/en'
import {myProjects} from './MyProjects/en'

export const myProject = {
  ...myProjectCandidates,
  ...myProjects,
}
